<template>
	<div class="py-1" role="none">
		<slot></slot>
	</div>
</template>
